import { Injectable } from "@angular/core";
import { AUserPermissionsService } from "@coso-replicator/core";
import { AuthService } from "@coso/saas-angular";
import { Observable, of } from "rxjs";
import { filter, map, take } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class UserPermissionsService implements AUserPermissionsService {
  constructor(private authService: AuthService) {}
  get hasFullControl$(): Observable<boolean> {
    return of(true);
  }
  get isAdmin$(): Observable<boolean> {
    return of(true);
  }
  get hasLimitedAccess$(): Observable<boolean> {
    return of(false);
  }
  get isCustomerAgent$(): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      filter((u) => u === true),
      take(1),
      map(() => this.authService.getIdentityClaims()),
      map((c) => c["role"] && c["role"].includes("CustomerSupportAgent"))
    );
  }
}
